export const ErrorCodes = {
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  UPDATE_FAILED: 'UPDATE_FAILED'
};

export const ErrorMessages = {
  INVALID_CREDENTIALS: 'error_invalid_credentials',
  ACCOUNT_LOCKED: 'error_account_locked',
  EMAIL_EXISTS: 'error_email_exists'
};
